import client from '../axios'
import {POST_JOINCOUNSEL_SEND_ALIMTALK,POST_JOINCOUNSEL, GET_JOINCOUNSEL_DETAIL, PUT_JOINCOUNSEL, DELETE_JOINCOUNSEL, PUT_JOINCOUNSEL_APPROVAL, PUT_JOINCOUNSEL_APP_APPROVAL, GET_MEMBER_FIRST_BOOK} from 'api/endpoint';

//입회 상담 등록
export const postJoinCounselAPI = (data) => {
  return client.post(POST_JOINCOUNSEL, data);
}
//상세
export const getJoinCounselAPI = (idx) => {
  const url = GET_JOINCOUNSEL_DETAIL.replace(':idx',idx)
  return client.get(url);
}
//수정
export const putJoinCounselAPI = (data) => {
  return client.put(PUT_JOINCOUNSEL, data);
}
//삭제
export const deleteJoinCounselAPI = (idx) => {
  return client.delete(DELETE_JOINCOUNSEL.replace(':idx',idx));
};
//입회승인
export const putJoinCounselApprovalAPI = (data) => {
  return client.put(PUT_JOINCOUNSEL_APPROVAL, data);
}

//입회 상담 수정-웹에서 회원이 직접 등록
export const putJoinAppCounselAPI = (data) => {
  return client.put(PUT_JOINCOUNSEL_APP_APPROVAL, data);
}

//알림톡 발송
export const postJoinCounselSendAlimtalkAPI = (data) => {
  return client.post(POST_JOINCOUNSEL_SEND_ALIMTALK, data);
}

//입회승인 첫진도
export const getMemberFirstBookAPI = (idx) => {
  return client.get(GET_MEMBER_FIRST_BOOK.replace(':join_counsel_idx', idx));
};